import React, { useState } from "react";
import OpenAI from "openai";
import ReactMarkdown from "react-markdown";
import "./AiChat.scss";

export default function AiChat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false); // Track loading state

  const openai = new OpenAI({
    apiKey: process.env.REACT_APP_API_KEY,
    dangerouslyAllowBrowser: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const newMessages = [...messages, { text: input, sender: "user" }];
    setMessages(newMessages);
    setInput("");
    setLoading(true); // Start loading

    try {
      const response = await openai.chat.completions.create({
        model: "gpt-4o-mini",
        messages: newMessages.map((msg) => ({
          role: msg.sender === "user" ? "user" : "assistant",
          content: msg.text,
        })),
      });

      const aiReply = response.choices[0]?.message?.content || "No response";
      setMessages([...newMessages, { text: aiReply, sender: "ai" }]);
    } catch (error) {
      console.error("Error fetching AI response:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="ai-chat">
      <div className="ai-chat__messages-container">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`ai-chat__message ai-chat__message--${message.sender}`}
          >
            <div className="ai-chat__avatar">
              {message.sender === "user" ? "U" : "A"}
            </div>
            <div className="ai-chat__message-content">
              {message.sender === "ai" ? (
                <ReactMarkdown>{message.text}</ReactMarkdown>
              ) : (
                message.text
              )}
            </div>
          </div>
        ))}
        {loading && (
          <div className="ai-chat__message ai-chat__message--ai">
            <div className="ai-chat__avatar">A</div>
            <div className="ai-chat__message-content ai-chat__skeleton"></div>
          </div>
        )}
      </div>
      <form className="ai-chat__form" onSubmit={handleSubmit}>
        <input
          className="ai-chat__input"
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
        />
        <button className="ai-chat__submit-btn" type="submit">
          Send
        </button>
      </form>
    </div>
  );
}
